// extracted by mini-css-extract-plugin
export default {"recos":"y5-z","productCardOverride":"z5-z","rowHasBadge":"A5-z"};